import { Group } from "src/api/search_v2/api";

export enum ImageSearchState {
  IDLE = "IDLE",
  LOADING = "LOADING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum ImageSearchErrorType {
  FORMAT = "FORMAT",
  DECODE_UNSUPPORTED = "DECODE_UNSUPPORTED",
  SIZE = "SIZE",
  NETWORK = "NETWORK",
}

export interface DetectedItem {
  id: string;
  croppedImage: string;
}

export interface ImageSearchResults {
  detectedItems: DetectedItem[];
  resultsByItem: Record<string, Group[]>;
}
